import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Valentina',
    age: 31,
    role: 'Mamá de gemelos, vende ropa infantil online',
    color: '#E8734A',
    quote: <>
          Cada vez que me sentaba a trabajar{' '}
          <strong className="text-[#E8734A]" data-id="element-340">me quedaba en blanco</strong>.
          Revisaba Instagram, respondía mensajes que no eran urgentes y de
          repente los niños ya se habían despertado. Empecé a usar el{' '}
          <strong className="text-[#D4A853]" data-id="element-341">Apagón del Caos</strong> antes de
          cada sesión. Al tercer día noté algo diferente. Llegaba a la laptop
          con una claridad que no había tenido en meses.{' '}
          <strong className="text-[#E8734A]" data-id="element-342">
            En 3 semanas dupliqué mis ventas sin trabajar más horas.
          </strong>{' '}
          Solo cambié cómo llegaba a trabajar.
        </>
  }, {
    name: 'Marcela',
    age: 38,
    role: 'Mamá, coach de nutrición',
    color: '#D4A853',
    quote: <>
          Mi problema era{' '}
          <strong className="text-[#E8734A]" data-id="element-343">
            el bajón de las 3 de la tarde
          </strong>
          . Justo cuando necesitaba terminar mis últimas tareas, me sentía
          completamente fundida. Ahora tengo mi{' '}
          <strong className="text-[#D4A853]" data-id="element-344">ritual de las 2:45PM</strong>. Me
          levanto, camino, agua fría en las muñecas y{' '}
          <strong className="text-[#D4A853]" data-id="element-345">en 60 segundos estoy lista</strong>
          . Termino mi jornada a las 4PM con todo hecho y{' '}
          <strong className="text-[#E8734A]" data-id="element-346">
            tengo energía real para estar con mi hija
          </strong>
          . Eso no tiene precio.
        </>
  }, {
    name: 'Sofía',
    age: 44,
    role: 'Mamá de 3 hijos, diseñadora freelance',
    color: '#2D2D2D',
    quote: <>
          Siempre intentaba hacer mis diseños más creativos por las tardes.
          Cuando descubrí que{' '}
          <strong className="text-[#D4A853]" data-id="element-347">
            mi pico creativo era entre las 7 y las 9 de la mañana
          </strong>
          , reorganicé todo.{' '}
          <strong className="text-[#E8734A]" data-id="element-348">
            Mis clientes me dicen que mi trabajo mejoró.
          </strong>{' '}
          Yo solo cambié el horario en el que uso{' '}
          <strong className="text-[#D4A853]" data-id="element-349">mi mejor cerebro</strong>.
        </>
  }];
  return <section className="w-full bg-white px-4 md:px-6 py-6 md:py-24 text-center" data-id="element-350">
      <div className="max-w-4xl mx-auto" data-id="element-351">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-352">
          <p className="text-sm uppercase tracking-[0.2em] text-[#D4A853] font-bold mb-3 md:mb-4" data-id="element-353">
            Testimonios reales
          </p>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D] mb-3 md:mb-4" data-id="element-354">
            Lo que cambió cuando{' '}
            <span className="text-[#E8734A]" data-id="element-355">lo entendieron</span>
          </h2>
          <p className="text-xl text-[#2D2D2D] mb-5 md:mb-14 font-medium opacity-70 max-w-2xl mx-auto" data-id="element-356">
            Mamás reales que dejaron de luchar contra su biología y empezaron a
            trabajar con ella
          </p>

          <div className="space-y-3 md:space-y-8 text-left" data-id="element-357">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="bg-[#FFF8F0] rounded-2xl md:rounded-3xl p-4 md:p-10 shadow-lg border border-[#F5E6DC] relative overflow-hidden" data-id="element-358">
                {/* Accent bar matching avatar color */}
                <div className="absolute top-0 left-0 w-full h-1.5" style={{
              backgroundColor: testimonial.color
            }} data-id="element-359" />

                <QuoteIcon className="absolute top-8 right-8 w-16 h-16 opacity-5" style={{
              color: testimonial.color
            }} data-id="element-360" />

                <div className="flex flex-col md:flex-row items-center md:items-start gap-3 md:gap-6 mb-3 md:mb-8 text-center md:text-left" data-id="element-361">
                  <div className="w-16 md:w-20 h-16 md:h-20 rounded-2xl flex items-center justify-center text-white text-2xl md:text-3xl font-bold shadow-lg flex-shrink-0" style={{
                backgroundColor: testimonial.color
              }} data-id="element-362">
                    {testimonial.name[0]}
                  </div>
                  <div className="pt-1" data-id="element-363">
                    <h3 className="font-bold text-xl text-[#2D2D2D] mb-1" data-id="element-364">
                      {testimonial.name},{' '}
                      <span className="text-[#D4A853]" data-id="element-365">
                        {testimonial.age} años
                      </span>
                    </h3>
                    <p className="text-[#2D2D2D] font-medium opacity-60 text-sm" data-id="element-366">
                      {testimonial.role}
                    </p>
                  </div>
                </div>

                <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 border border-[#F5E6DC]" data-id="element-367">
                  <p className="text-[#2D2D2D] text-base md:text-lg leading-relaxed italic text-center md:text-left" data-id="element-368">
                    "{testimonial.quote}"
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}